/* eslint-disable react-hooks/exhaustive-deps*/
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, Redirect, Link } from 'react-router-dom';
import ReactCodeInput from 'react-verification-code-input';

import VivekaLogo from '../../assets/viveka-logo.png';
import css from './SignUpPage.module.css';
import cssm from './Method.css';
import ContainerWrapper from '../../custom-components/wrappers/container-wrapper/ContainerWrapper';
import PageWrapper from '../../custom-components/wrappers/page-wrapper/PageWrapper';
import Footer from '../../custom-components/elements/footer/Footer';
// import AccountTypeCard from '../../custom-components/elements/account-type/AccountType';

// import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope, faUser } from '@fortawesome/free-solid-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons';

import Coach from '../../custom-components/elements/account-type/coach.png';
import CoachGold from '../../custom-components/elements/account-type/coach_gold.png';
import NotCoach from '../../custom-components/elements/account-type/not_coach.png';
import NotCoachGold from '../../custom-components/elements/account-type/not_coach_gold.png';
import SelectedTop from '../../custom-components/elements/account-type/selected_top.png';

import Button from '../../custom-components/elements/Button/Button';
// import CheckBox from '../../custom-components/elements/checkbox/CheckBox';
import InputText from '../../custom-components/elements/input-text/InputText';

import NavBar from '../../custom-components/elements/nav-bar/NavBar';
import NavBarWrapper from '../../custom-components/wrappers/navbar-wrapper/NavBarWrapper';

import classnames from 'classnames';

import { authenticationInProgress, signup, login } from '../../ducks/Auth.duck';
import {
  isSignupEmailTakenError,
  // isTooManyEmailVerificationRequestsError,
} from '../../util/errors';
import { FormattedMessage } from '../../util/reactIntl';

// import { number } from 'prop-types';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import FacebookLogin from 'react-facebook-login';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import { NamedRedirect } from '../../components';
import { ensureCurrentUser } from '../../util/data';
import MainDashboardWrapper from '../../components/MainDashboardWrapper/MainDashboardWrapper';
import PublicPageWrapper from '../../components/PublicPageWrapper/PublicPageWrapper';

function SignUpPage(props) {
  const { match, location, isAuthenticated, currentUser } = props;
  // const showSignUp = true;
  // const showAccountType = false;
  // const showVerifyEmail = false;

  const [errors, setErrors] = useState({
    firstName: null,
    lastName: null,
    email: null,
    password: null,
    confirmedPassword: null,
  });

  const [credentials, setCredentials] = useState({
    firstName: null,
    lastName: null,
    email: null,
    password: null,
    confirmedPassword: null,
  });

  const [userType, setUserType] = useState('lfc');

  const user = ensureCurrentUser(currentUser);
  const currentUserLoaded = !!user.id;

  const from = location.state && location.state.from ? location.state.from : null;
  const iamCoach = location.state && location.state.iamCoach ? location.state.iamCoach : null;
  const fixedEmail = location.state && location.state.email;
  const providerLogo = location.state && location.state.providerLogo;
  const redirectUrl = location.state && location.state.redirectUrl;
  // console.log(location.state);

  useEffect(() => {
    if (iamCoach) {
      setUserType('iac');
    }
  }, [iamCoach]);

  useEffect(() => {
    const userType = new URLSearchParams(location.search).get('uType');
    if (userType) {
      setUserType(userType === 'iac' ? 'iac' : 'lfc');
    }
  }, [location]);

  // redirectIfAuthed();

  if (isAuthenticated && from) {
    return <Redirect to={from} />;
  } else if (isAuthenticated && currentUserLoaded) {
    return <NamedRedirect name="LandingPage" />;
  }

  if (isAuthenticated) {
    return <Redirect to="/s" />;
  }

  if (isAuthenticated && userType === 'iac') {
    return <Redirect to="/account/payments" />;
    // return <Redirect to="/s" />;
  } else if (isAuthenticated && userType === 'lfc') {
    return <Redirect to="/s" />;
  }

  // function hash(str) {
  //   const hashCode = str
  //     .split('')
  //     .reduce((prevHash, currVal) => ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0, 0);
  //   return hashCode.toString();
  // }

  // const responseFacebook = res => {
  //   if (res && res.accessToken) {
  //     const p = hash(res.userID);
  //     let tempParams = {};
  //     tempParams.firstName = res.name.split(' ')[0];
  //     tempParams.lastName = res.name.split(' ')[1];
  //     tempParams.email = res.email;
  //     tempParams.password = p;
  //     tempParams.confirmedPassword = p;
  //     submitCreds(tempParams).catch(e => {
  //       props.submitLogin({ email: res.email, password: p });
  //     });
  //   }
  // };

  // const FacebookContent = () => {
  //   return (
  //     <FacebookLogin
  //       appId="234694264411720"
  //       autoLoad={false}
  //       fields="name,email"
  //       callback={responseFacebook}
  //       render={renderProps => (
  //         <div onClick={renderProps.onClick} className={cssm.facebook}>
  //           <FontAwesomeIcon className={cssm.icon} icon={faFacebookF} />
  //           Sign up with Facebook
  //         </div>
  //       )}
  //     />
  //   );
  // };

  const signupErrorMessage = (
    <div className={css.error}>
      {isSignupEmailTakenError(props.signupError) ? (
        <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
      ) : (
        <FormattedMessage id="AuthenticationPage.signupFailed" />
      )}
    </div>
  );

  const errorMessage = (error, message) => (error ? message : null);
  const loginOrSignupError = errorMessage(props.signupError, signupErrorMessage);

  const signupMethod = (
    <div className={cssm.wrapper}>
      <h2>
        <span>Create</span> Account
      </h2>
      <div className={cssm.buttons}>
        {/* <FacebookContent /> */}
        <div className={cssm.email} onClick={() => props.history.push('/signup/type')}>
          Sign up with Email
        </div>
      </div>
      <p className={cssm.login}>Already on Viveka? Log In</p>
    </div>
  );

  const signUpContent = (
    <div className={css.signUpContent}>
      <p>
        <span>Create</span> <span> Account</span>
      </p>

      <div>
        <InputText
          onC={onChangeFirstName}
          className={css.inputComp}
          icon={faUser}
          placeholder="First Name"
          type="text"
        />
        {errors.firstName ? <span style={{ color: 'red' }}>{'First name is missing'}</span> : null}
      </div>
      <div>
        <InputText
          onC={onChangeLastName}
          className={css.inputComp}
          icon={faUser}
          placeholder="Last Name"
          type="text"
        />
        {errors.lastName ? <span style={{ color: 'red' }}>{'Last name is missing'}</span> : null}
      </div>
      <div>
        <InputText
          onC={onChangeEmail}
          className={css.inputComp}
          icon={faEnvelope}
          placeholder="Email Address"
          type="text"
          isDisabled={!!fixedEmail}
          parentValue={fixedEmail}
        />
        {errors.email ? <span style={{ color: 'red' }}>{'Email is missing '}</span> : null}
        {/* {credentials.email && !errors.email && /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(credentials.email) ? null : <span style={{color: "red"}}>{"Email is not valid"}</span>} */}
      </div>
      <div>
        <InputText
          onC={onChangePassword}
          className={css.inputComp}
          icon={faLock}
          placeholder="Password"
          type="password"
        />
        {errors.password ? <span style={{ color: 'red' }}>{'Password is missing'}</span> : null}
        {credentials.password && credentials.password.length < 8 ? (
          <span style={{ color: 'red' }}>{'Password has to be more than 8 characters'}</span>
        ) : null}
      </div>
      <div>
        <InputText
          onC={onChangeConfirmedPassword}
          className={css.inputComp}
          icon={faLock}
          placeholder="Confirm Password"
          type="password"
        />
        {errors.confirmedPassword ? (
          <span style={{ color: 'red' }}>{'Confirm password is missing'}</span>
        ) : null}
        {credentials.password &&
        credentials.confirmedPassword &&
        credentials.password !== credentials.confirmedPassword ? (
          <span style={{ color: 'red' }}>{'Passwords do not match'}</span>
        ) : null}
      </div>

      <div className={css.errorMessage}>{loginOrSignupError}</div>
      <div className={css.button}>
        <Button onclick={() => submitCreds(credentials)} text="Sign Up" />
      </div>
      <div></div>
      {/* <div className={css.signinBlock}>
        <p> Already on Viveka ? </p>
        <Button to="/login" text="Log in" type="textonly" />
      </div> */}
    </div>
  );

  const accountTypeContent = (
    <div>
      <p>
        <span>Select an </span> Account type
      </p>

      <div className={css.cardPadding}>
        <div
          onClick={() => setUserType('iac')}
          className={classnames(
            css.accountTypeCard,
            userType === 'iac' && css.accountTypeCardSelected
          )}
        >
          {userType === 'iac' && (
            <img className={css.selectedIcon} alt="selected icom" src={SelectedTop} />
          )}
          <img
            className={css.userTypeImage}
            alt="Coach"
            src={userType === 'iac' ? CoachGold : Coach}
          />
          <p>I am a</p>
          <p>Service provider</p>
        </div>
        <div
          onClick={() => setUserType('lfc')}
          className={classnames(
            css.accountTypeCard,
            userType === 'lfc' && css.accountTypeCardSelected
          )}
        >
          {userType === 'lfc' && (
            <img className={css.selectedIcon} alt="selected icon" src={SelectedTop} />
          )}
          <img
            className={css.userTypeImage}
            alt="Not Coach"
            src={userType === 'lfc' ? NotCoachGold : NotCoach}
          />
          <p>I am looking for</p>
          <p>a Service provider</p>
        </div>
      </div>

      {/* <div>
        <CheckBox label={'I agree to the privacy & terms of service.'} cols={40} rows={10} />
      </div> */}

      <div className={css.justifySpaceRow}>
        {/* <div className={css.signinButton}>
          <Button to="/login" text="Log In" type="primary" />
        </div> */}
        <div>
          <Button
            onclick={() => props.history.push('/signup/emailsignup', { from: from })}
            text="Next"
            type="primary"
          />
        </div>
      </div>

      {/* <div className={css.signinBlock}>
        <p> Already on Viveka ? </p>
        <p> Log In </p>
      </div> */}
    </div>
  );

  const verifyEmailContent = (
    <div>
      <p>
        <span>Verify </span> Email
      </p>
      <p>
        <span>Pleasew enter the 4 digit code send to your email</span>
      </p>

      <div className={css.codeInputOuterDiv}>
        <ReactCodeInput className={css.codeInput} fields={4} />
      </div>
      <div className={css.resendButton}>
        <Button text="Resend Code" type="textonly" />
      </div>
      <div className={css.rowBottomDiv}>
        <Button text="Back" type="textonlyiconleft" icon={faArrowAltCircleRight} />
        <Button text="Verify Now" type="primary" />
      </div>
      <div className={css.signinBlock}>
        <p> Already on Viveka ? </p>
        <p> Log In </p>
      </div>
    </div>
  );

  // if (showSignUp) {
  //   content = signUpContent;
  // }

  // if (showAccountType) {
  //   content = accountTypeContent;
  // }

  // if (showVerifyEmail) {
  //   content = verifyEmailContent;
  // }

  const getView = key => {
    switch (key) {
      case 'method':
        return signupMethod;
      case 'emailsignup':
        return signUpContent;
      case 'type':
        return accountTypeContent;
      case 'verify':
        return verifyEmailContent;
      default:
        return signupMethod;
    }
  };

  return (
    <PageWrapper>
      {/*<ContainerWrapper>*/}
      {/*  <NavBarWrapper>*/}
      {/*    <NavBar />*/}
      {/*  </NavBarWrapper>*/}
      {/*</ContainerWrapper>*/}
      <PublicPageWrapper>
        <ContainerWrapper>
          <div className={css.outerbase}>
            <div className={css.base}>
              <div className={css.leftDiv}>
                <div>
                  <img className={css.logo} alt="Logo" src={providerLogo || VivekaLogo} />
                </div>
                <div>{getView(match.params.step)}</div>
              </div>
              <div className={css.rightDiv}>
                <div>
                  <p>Where Knowledge</p>
                  <p>Leads And</p>
                  <p>Experts Connect</p>
                </div>
              </div>
            </div>
          </div>
        </ContainerWrapper>

        <ContainerWrapper>
          <Footer />
        </ContainerWrapper>
      </PublicPageWrapper>
    </PageWrapper>
  );

  // function redirectIfAuthed() {
  //   if (props.isAuthenticated) {
  //     props.history.push('/');
  //   }
  // }

  function onChangeFirstName(e) {
    setCredentials({
      firstName: e.target.value,
      lastName: credentials.lastName,
      email: credentials.email,
      password: credentials.password,
      confirmedPassword: credentials.confirmedPassword,
    });
  }

  function onChangeLastName(e) {
    setCredentials({
      firstName: credentials.firstName,
      lastName: e.target.value,
      email: credentials.email,
      password: credentials.password,
      confirmedPassword: credentials.confirmedPassword,
    });
  }

  function onChangeEmail(e) {
    setCredentials({
      firstName: credentials.firstName,
      lastName: credentials.lastName,
      email: e.target.value,
      password: credentials.password,
      confirmedPassword: credentials.confirmedPassword,
    });
  }

  function onChangePassword(e) {
    setCredentials({
      firstName: credentials.firstName,
      lastName: credentials.lastName,
      email: credentials.email,
      password: e.target.value,
      confirmedPassword: credentials.confirmedPassword,
    });
  }

  function onChangeConfirmedPassword(e) {
    setCredentials({
      firstName: credentials.firstName,
      lastName: credentials.lastName,
      email: credentials.email,
      password: credentials.password,
      confirmedPassword: e.target.value,
    });
  }

  function submitCreds(params) {
    const { firstName, lastName, email, password, confirmedPassword } = params;

    //not the final validation
    if (firstName === null || firstName === '') {
      //alert('First Name is missing');
      setErrors({
        firstName: true,
      });
      return;
    } else {
      setErrors({
        firstName: false,
      });
    }

    if (lastName === null || lastName === '') {
      setErrors({
        lastName: true,
      });
      return;
    } else {
      setErrors({
        lastName: false,
      });
    }

    if (email === null || email === '') {
      setErrors({
        email: true,
      });
      return;
    } else {
      setErrors({
        email: false,
      });
    }

    if (password === null || password === '') {
      setErrors({
        password: true,
      });
      return;
    } else {
      setErrors({
        password: false,
      });
    }

    if (confirmedPassword === null || confirmedPassword === '') {
      setErrors({
        confirmedPassword: true,
      });
      return;
    } else {
      setErrors({
        confirmedPassword: false,
      });
    }

    // if (
    //   credentials.password &&
    //   credentials.confirmedPassword &&
    //   credentials.password !== credentials.confirmedPassword
    // ) {
    //   alert('Passwords do not match');
    //   return;
    // }

    // if (credentials.password && credentials.password.length < 8) {
    //   alert('Password has to be more than 8 characters');
    //   return;
    // }

    const tempParams = {
      firstName,
      lastName,
      email,
      password,
    };

    //lfc = looking for a coach
    //iac = i am a coach

    props.submitSignup(tempParams, userType).then(() => {
      if (window && window.dataLayer) {
        console.log('event pushed');

        let dataLayerObj;
        if (userType === 'iac') {
          dataLayerObj = {
            event: 'coachSignup',
          };
        } else {
          dataLayerObj = {
            event: 'clientSignup',
          };
        }
        window.dataLayer.push(dataLayerObj);
      }

      if (redirectUrl) {
        props.history.push(redirectUrl);
      }
    });
  }
}

const mapStateToProps = state => {
  const { isAuthenticated, loginError, signupError } = state.Auth;
  const { currentUser } = state.user;
  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    isAuthenticated,
    loginError,
    signupError,
  };
};

const mapDispatchToProps = dispatch => ({
  //submitSignup: ({ firstName, lastName, email, password, confirmedPassword}) => dispatch(signup(firstName, lastName, email, password, confirmedPassword)),
  submitSignup: (params, type) => dispatch(signup(params, type)),
  submitLogin: ({ email, password }) => dispatch(login(email, password)),
});

//export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LoginPage);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(SignUpPage);
